export default [
  'system',
  'entry',
  'permission',
  'graph',
  'guanjia',
  'case',
  'celve1',
  'shoucang',
  'deal-type',
  'pm',
  'shoukuan',
  'zhibiao',
  'puzzle',
  'user-group',
  'yuce',
  'jianmo',
  'zhuanzhang',
  'yunwei',
  'baozhang',
  'jizhang',
  'tongji',
  'pingfen',
  'limit',
  'spider',
  'loan',
  'access',
  'role',
  'org',
  'celve',
  'book',
  'tag',
  'shixufenxipeizhi',
  'all-cases',
  'xianeguanli',
  'api',
  'network',
  'analysis',
  'calendar',
  'backup',
  'all',
  'attachment',
  'chart-line',
  'branches',
  'chart-area',
  'clock',
  'check',
  'charging-setting',
  'chart-pie-alt',
  'dashboard',
  'datebase',
  'check-reply',
  'datacenter',
  'connection',
  'download',
  'date-set',
  'event',
  'event-wait',
  'fieldanalysis',
  'exchange',
  'knowledge',
  'key',
  'log',
  'list',
  'menu',
  'index',
  'project',
  'monitorin',
  'pointmap',
  'ranking',
  'model',
  'plan',
  'task',
  'wait',
  'upload',
  'question-list',
  'read',
  'setting',
  'reply',
  'jinjianguanli',
  'change-theme',
  'application',
  'flag-en',
  'flag-cn',
  'down',
  'up',
  'workflow',
  'sync',
  'folder',
  'database',
  'circle',
  'edit',
  'edit-color',
  'box',
  'layer',
  'box-color',
  'home-color',
  'record',
  'monitor',
  'time-color',
  'user',
  'function-color',
  'record-color',
  'warning-color',
  'layer-color',
  'template',
  'template-color',
  'monitor-color',
  'search',
  'user-color',
  'function',
  'warning',
  'search-color',
  'home',
  'time',
  'application',
  'plus',
  'minus',
]
